import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Lock } from 'lucide-react';
import { LogoMain } from '../components/Logo';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) {
      if (user.role === 'vendor') navigate('/vendor');
      else navigate('/admin');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const result = await login(formData.email, formData.password);
    if (result.success) {
      if (result.role === 'vendor') navigate('/vendor');
      else navigate('/admin');
    } else {
      setError(result.error || 'E-posta veya şifre hatalı.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Link to="/" data-testid="logo-link" className="inline-block">
            <LogoMain height={32} />
          </Link>
          <p className="text-xs font-medium text-[#666] tracking-wide mt-2">Bağımsız Test. Net Sonuç.</p>
          <div className="flex items-center justify-center gap-2 mt-6">
            <Lock className="w-5 h-5 text-[#1C3B2A]" strokeWidth={2.5} />
            <p className="text-lg font-semibold uppercase tracking-tight text-[#111]">Giriş</p>
          </div>
        </div>
        <div className="bg-white border border-neutral-200 rounded-lg shadow-sm p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-50 text-red-700 border border-red-200 px-4 py-3 rounded-lg text-sm font-medium" data-testid="error-message">
                {error}
              </div>
            )}
            <div>
              <label className="block text-xs font-semibold tracking-wide uppercase mb-2 text-[#666]" htmlFor="email">E-posta</label>
              <input type="email" id="email" value={formData.email}
                onChange={(e) => { setFormData(p => ({ ...p, email: e.target.value })); setError(''); }}
                required className="w-full border border-neutral-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1C3B2A]"
                data-testid="input-email" />
            </div>
            <div>
              <label className="block text-xs font-semibold tracking-wide uppercase mb-2 text-[#666]" htmlFor="password">Şifre</label>
              <input type="password" id="password" value={formData.password}
                onChange={(e) => { setFormData(p => ({ ...p, password: e.target.value })); setError(''); }}
                required className="w-full border border-neutral-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1C3B2A]"
                data-testid="input-password" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#1C3B2A] text-white px-8 py-3 font-semibold uppercase text-sm rounded-lg hover:bg-[#152e21] transition disabled:opacity-50"
              data-testid="login-button">
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        </div>
        <div className="text-center mt-6">
          <Link to="/" className="text-sm font-medium text-[#666] hover:text-[#1C3B2A] transition">&larr; Ana Sayfaya Dön</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
